import { t } from '@exam-prep/i18n';
import { Button } from '@exam-prep/ui';
import { useLoad } from '../../lib/useLoad';
import { api } from '../../lib/api';
import type { Result as ResultData, Leaderboard } from '../../lib/api-types';
import { ErrorBox, Loading } from '../../components/Feedback';
import { useShareCard } from './hooks/useShareCard';
import { LeaderboardCard, ScoreCard, SectionsCard, SolutionsCard } from './ui/ResultCards';

export function Result({ attemptId, onBack }: { attemptId: string; onBack: () => void }) {
  const { data, error, reload } = useLoad(
    () => api<ResultData>('GET', `/app/attempts/${attemptId}/result`),
    [attemptId],
  );
  const board = useLoad(
    async () =>
      data?.mock.ranked ? api<Leaderboard>('GET', `/app/mocks/${data.mock.id}/leaderboard`) : null,
    [data?.mock.id],
  );
  const { cardState, share } = useShareCard(data);
  if (error) return <ErrorBox error={error} retry={reload} />;
  if (!data) return <Loading />;
  return (
    <div className="space-y-4 p-4">
      <ScoreCard data={data} />
      <SectionsCard data={data} />
      {board.data && board.data.rows.length ? <LeaderboardCard rows={board.data.rows} /> : null}
      <SolutionsCard data={data} />

      <Button
        variant="amber"
        size="lg"
        className="w-full"
        onClick={() => void share()}
        disabled={cardState === 'busy'}
        pending={cardState === 'busy'}
      >
        {t(cardState === 'failed' ? 'miniapp.card.failed' : 'miniapp.card.share')}
      </Button>
      <Button variant="outline" size="lg" className="w-full" onClick={onBack}>
        {t('miniapp.result.back')}
      </Button>
    </div>
  );
}
